module.exports = __webpack_public_path__ + "img/s2P21.f701b039.png";